import React from 'react';
import PropTypes from 'prop-types';
import { withStyles, createStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import { Popover, Typography } from '@material-ui/core';
import { connect } from 'react-redux';
import { getPerfilTecnicoInterno } from '../../provider/laudo-avaliacao-service';
import { AccountCircle } from '@material-ui/icons';
import MoreIcon from '@material-ui/icons/MoreVert';

const styles = (theme) =>
  createStyles({
    root: {
      width: '100%',
    },
    grow: {
      flexGrow: 1,
    },
    inputRoot: {
      color: 'inherit',
      width: '100%',
    },
    inputInput: {
      paddingTop: theme.spacing(0),
      paddingRight: theme.spacing(0),
      paddingBottom: theme.spacing(0),
      paddingLeft: theme.spacing(10),
      transition: theme.transitions.create('width'),
      width: '100%',
      [theme.breakpoints.up('md')]: {
        width: 200,
      },
    },
    sectionDesktop: {
      display: 'none',
      [theme.breakpoints.up('md')]: {
        display: 'flex',
      },
    },
    sectionMobile: {
      display: 'flex',
      [theme.breakpoints.up('md')]: {
        display: 'none',
      },
    },
    typography: {
      padding: theme.spacing(2),
    },
  });

interface Props {
  classes: any;
  user: any;
}

class User extends React.Component<Props> {
  state = {
    anchorEl: null,
    mobileMoreAnchorEl: null,
    empregado: null,
  };

  handleProfileMenuOpen = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleMobileMenuOpen = (event) => {
    this.setState({ mobileMoreAnchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };
  static propTypes: {
    classes: PropTypes.Validator<object>;
    user: PropTypes.Validator<object>;
  };

  componentDidMount() {
    if (!this.props.user.isTecnicoExterno) {
      getPerfilTecnicoInterno(this.props.user.matricula)
        .then((res) => {
          this.setState({ empregado: res.data });
        })
        .catch((e) => {
          console.error('ERROR! ', e);
        });
    }
  }

  render() {
    const { anchorEl, empregado }: any = this.state;
    const { classes } = this.props;
    const isMenuOpen = Boolean(anchorEl);
    const popOverOpen = Boolean(anchorEl);

    return (
      <div>
        <div className={classes.grow} />
        <div className={classes.sectionDesktop}>
          <IconButton
            aria-owns={isMenuOpen ? 'material-appbar' : undefined}
            aria-haspopup="true"
            onClick={this.handleProfileMenuOpen}
            color="inherit"
          >
            <AccountCircle />
          </IconButton>
        </div>
        <div className={classes.sectionMobile}>
          <IconButton
            aria-haspopup="true"
            onClick={this.handleMobileMenuOpen}
            color="inherit"
          >
            <MoreIcon />
          </IconButton>
        </div>
        <Popover
          id="simple-popover"
          open={popOverOpen}
          anchorEl={anchorEl}
          onClose={this.handleClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
        >
          <Typography className={classes.typography}>
            <strong>Nome: </strong>
            {this.props.user.nome}
            <br />
            {this.props.user.isTecnicoExterno ? (
              <div>
                <strong>CPF: </strong>
                {this.props.user.cpf.toString().replace(
                  /^(\d{3})(\d{3})(\d{3})(\d{2})$/,
                  '$1.$2.$3-$4',
                )}
                <br />
                <strong>Lotação: </strong>
                {this.props.user.nomeEmpresa}
              </div>
            ) : (
              <div>
                <strong>Matrícula: </strong>
                {this.props.user.matricula}
                <br />
                <strong>Lotação: </strong>
                {empregado?.lotacao?.lotacaoFisicaTO?.descricao}
              </div>
            )}
            <strong>Grupo de Acesso: </strong>TÉCNICO
          </Typography>
        </Popover>
      </div>
    );
  }
}

User.propTypes = {
  classes: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
  return {
    user: state.usuarioLogadoState.usuarioLogado,
  };
};

export default withStyles(styles)(connect(mapStateToProps)(User));
